<template>
  <div v-if="showText || !edit" style="width: 100%;height:100%;" @click="onTextClick">
    <span>{{ text }}
      <!--      {{ typeof value }} {{ value }} edit {{ edit }}-->
    </span>
  </div>
  <el-select
    v-else
    ref="elSelect"
    :value="(optionField.type === 'number'?Number(value):value)||''"
    :filterable="filterable"
    :remote="filterable"
    :placeholder="$t('CargoMsg.Cargo_keyWordsTip')"
    :remote-method="remoteMethod"
    :loading="loading"
    :clearable="clearable"
    automatic-dropdown
    default-first-option
    @blur="onSelectBlur"
    @change="onChange"
    @visible-change="onVisibleChange"
  >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="optionField.labelFunc ? optionField.labelFunc(item) : item[optionField.label]"
      :value="item[optionField.value]"
    />
  </el-select>
</template>

<script>
let lastTriggeredAt // 用户远程搜索（记录最后一次触发时间）
export default {
  name: 'CargoCellSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    fullOptions: { type: Array, default: () => { return [] } },
    value: { type: [String, Number, Boolean], required: false, default: '' },
    field: { type: [String], required: false, default: '' },
    edit: { type: Boolean, default: false },
    optionField: { type: Object, required: false, default: () => { return { label: 'chineseName', value: 'code' } } }
  },
  data() {
    return {
      showText: true,
      wait: 100,
      options: [],
      filterable: true,
      clearable: false, // （是否有清空按钮操作）
      currentItem: {},
      neeDInitData: true,
      list: [],
      loading: false
    }
  },
  computed: {
    text() {
      if (this.optionField.labelFunc) {
        return this.getLabelFromLabelFunc(this.value)
      }
      const currentItem = this.currentItem
      if (currentItem) {
        return currentItem[this.optionField.label]
      }
    },
    showOption() {
      return this.edit && !this.showText
    }
  },
  watch: {
    value(val, old) {
      if (!val || val === old) return
      this.currentItem = this.fullOptions.find(item => item[this.optionField.value] === val)
      if (!this.currentItem) {
        this.currentItem[this.optionField.label] = this.optionField.labelFunc ? this.getLabelFromLabelFunc(val) : val
        this.currentItem[this.optionField.value] = val
        this.options.push(this.currentItem)
      }
    },
    showOption(val) {
      if (val && this.list.length === 0 && this.fullOptions.length > 0) {
        this.list = this.getList(this.fullOptions)
      }
      this.options = this.list
    }
  },
  mounted() {
    // console.log('渲染啦啦啦 ffield', this.field, this.fullOptions)
    this.clearable = this.optionField.clearable
    this.currentItem = this.fullOptions.find(item => item[this.optionField.value] === this.value)
    // console.log('this.currentItem' + this.optionField.value, this.optionField, this.value, this.currentItem)
  },
  methods: {
    onVisibleChange(show) {
      console.log('onVisibleChange-')
      if (!show) {
        // 隐藏
        this.showText = true
      } else {
        this.options = this.list
        // this.$refs.elSelect.hoverIndex = 0
      }
    },
    onTextClick() {
      if (this.edit) {
        this.showText = false
        this.$nextTick(() => {
          this.$refs.elSelect.focus()
        })
      }
    },
    onChange(val) {
      console.log('onChange')
      // eslint-disable-next-line eqeqeq 可能数字or字符串, eqeqeq
      this.currentItem = this.list.find(item => item[this.optionField.value] == val)
      console.log('val', val, 'this.value', this.value)
      this.$emit('change', val)
      this.$emit('cbChange', this.currentItem)
    },
    onSelectBlur(event) {
      console.log('onSelectBlur', event)
    },
    remoteMethod(keyword) {
      console.log('remoteMethod=========', this.field, 'keyword', keyword)
      if (keyword.length >= 1) {
        lastTriggeredAt = new Date().getTime()
        setTimeout(() => {
          const now = new Date().getTime()
          if ((now - this.wait) >= lastTriggeredAt) { // 严格来说，应该用===
            // this.loading = true （设置为true，远程加载数据有延迟，那么 将this.loading 置位 false也有延时。这些因素会导致 下拉列表抖动）
            this.loading = false
            let suitableCount = 0
            this.options = this.list.filter((item, index) => {
              if (suitableCount > 100) { return false }
              const match = (!keyword.trim()) || (this.optionField.labelFunc ? this.optionField.labelFunc(item) : item[this.optionField.label]).toLowerCase()
                .indexOf(keyword.toLowerCase()) > -1
              if (match) { suitableCount++ }
              return match
            })

            console.log('this.options==', this.options)
          } // 这个if判断用于：在this.wait长度的时间内，如果再次输入触发了setOptions，则会令“上一次”搜索不执行(因为本次改写了lastTriggeredAt的值)
        }, this.wait)
      }
    },
    getList(options) {
      return options.map(item => {
        // return { label: `${this.optionField.labelFunc ? this.optionField.labelFunc(item) : item[this.optionField.label]}`, value: `${item[this.optionField.value]}` }
        const currentVal = this.optionField.type === 'number' ? Number(item[this.optionField.value]) : item[this.optionField.value]
        return { ...item, [this.optionField.value]: currentVal }
      })
    },
    getLabelFromLabelFunc(val) {
      let item = {}
      if (this.currentItem) {
        item = this.currentItem
      } else {
        item[this.optionField.value] = val
      }
      return this.optionField.labelFunc ? this.optionField.labelFunc(item) : ''
    }
  }
}
</script>
